class HomeReviews {
  constructor() {
    this.wrapper = document.querySelector('.home-reviews');

    this.swiper = null;
    this.swiperEl = this.wrapper?.querySelector('.swiper');
    this.swiperWrapper = this.wrapper?.querySelector('.swiper-wrapper');

    this.init();
  }

  async init() {
    if (typeof Swiper !== 'undefined' && this.swiperEl) {
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 700,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        breakpoints: {
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 }
        }
      });
    }
    
    await this.loadReviews();
  }

  async loadReviews() {
    try {
      const cacheKey = `google-reviews-${Shopify.shop}`;
      const cacheTimeKey = `${cacheKey}-time`;

      const cacheDuration = 1000 * 60 * 60; // 1 hour

      const cachedData = localStorage.getItem(cacheKey);
      const cachedTime = localStorage.getItem(cacheTimeKey);
      
      let json = null;

      // Use cache if still valid
      if (
        cachedData &&
        cachedTime &&
        Date.now() - Number(cachedTime) < cacheDuration
      ) {
        json = JSON.parse(cachedData);
      } else {
        // Fetch new data
        const url = `https://widget-ms-grp.entanglecommerce.com/api/review-with-widgets?shop=${Shopify.shop}`;

        const response = await fetch(url);
        json = await response.json();

        // Save cache
        localStorage.setItem(cacheKey, JSON.stringify(json));
        localStorage.setItem(cacheTimeKey, Date.now().toString());
      }

      if (!json?.success || !json?.data?.reviews?.length) return;

      const rating = Number(json.data.rating || 0);
      const ratingPercent = (rating / 5) * 100;

      document.querySelectorAll('.google-rating-number').forEach((el) => {
        el.textContent = rating.toFixed(1);
      });

      document.querySelectorAll('.google-rating-percent').forEach((el) => {
        el.style.width = `${ratingPercent}%`;
      });

      if (this.swiper && this.swiperWrapper) {
        const slides = json.data.reviews.map((review) => {
          const words = review.text?.split(' ') || [];
          const limitedText = words.length > 100 ? `${words.slice(0, 100).join(' ')}...` : review.text || '';

          return `
            <div class="swiper-slide">
              <div class="card">
                ${limitedText}
              </div>
            </div>
          `;
        }).join('');

        this.swiperWrapper.innerHTML = slides;
        this.swiper.update();
      }

    } catch (error) {
      console.error('Failed to load reviews:', error);
    }
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
	new HomeReviews();
});